import { JSX } from 'preact';
import { AUTHOR_VARS } from './_shared';

export function authorColor(seed: string | number): string {
  if (typeof seed === 'number') {
    return AUTHOR_VARS[((seed % AUTHOR_VARS.length) + AUTHOR_VARS.length) % AUTHOR_VARS.length];
  }
  if (!seed) return AUTHOR_VARS[0];
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return AUTHOR_VARS[h % AUTHOR_VARS.length];
}

interface AvatarProps {
  name: string;
  color?: string;
  size?: number;
}

export function Avatar({ name, color, size = 32 }: AvatarProps): JSX.Element {
  const initials =
    name.trim().split(/\s+/).map(s => s[0]).slice(0, 2).join('').toUpperCase() || '?';
  const c = color || authorColor(name || 'X');
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: c,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--st-font-body)',
        fontSize: size * 0.38,
        fontWeight: 600,
        flexShrink: 0,
      }}
      aria-label={name}
    >
      {initials}
    </div>
  );
}

interface AvatarStackProps {
  colors?: string[];
  names?: string[];
  size?: number;
  overlap?: number;
}

export function AvatarStack({ colors = [], names, size = 32, overlap = 10 }: AvatarStackProps): JSX.Element {
  const list = colors.length > 0 ? colors : (names ?? []).map(n => authorColor(n));
  return (
    <div style={{ display: 'flex' }}>
      {list.map((c, i) => (
        <div
          key={i}
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            background: c,
            marginLeft: i === 0 ? 0 : -overlap,
            border: '2px solid var(--st-surface-base)',
            zIndex: list.length - i,
          }}
          aria-hidden="true"
        />
      ))}
    </div>
  );
}
